import { render, staticRenderFns } from "./SampleHeader.vue?vue&type=template&id=2fd50773"
import script from "./SampleHeader.vue?vue&type=script&lang=js"
export * from "./SampleHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fd50773')) {
      api.createRecord('2fd50773', component.options)
    } else {
      api.reload('2fd50773', component.options)
    }
    module.hot.accept("./SampleHeader.vue?vue&type=template&id=2fd50773", function () {
      api.rerender('2fd50773', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/SampleHeader.vue"
export default component.exports